import { IoMdClose } from 'react-icons/io';
import Button from '../button/Button';
import Text from '../text/Text';
import ActionButton from './ActionButton';

type CloseButtonProps = {
  onClick: () => void;
  type: 'black' | 'white';
};

type CloseActionButtonProps = {
  onClose: () => void;
  color?: 'black' | 'white';
};

const CloseButton = ({ onClick, type }: CloseButtonProps) => {
  return (
    <Button
      type='transparent'
      width='content-width'
      onClick={onClick}
      style={type === 'white' ? { color: 'white' } : {}}
    >
      <IoMdClose size={20} />
    </Button>
  );
};

const CloseActionButton = ({
  onClose,
  color = 'black',
}: CloseActionButtonProps) => (
  <ActionButton
    onConfirm={onClose}
    closeButtonType={color}
    MainButton={CloseButton}
    popUpText={<Text>Are you sure you want to close the module?</Text>}
    skipButtonText='Cancel'
    confirmButtonText='Close'
    popUpHeader='Close module'
  />
);

export default CloseActionButton;
